import { unitDefault, unitTypes, timeJump } from "@/settings/unitTypes";
export const Oven = {
  id: "50",
  name: "Horno",
  mainClass: "Estático",
  subtype: "",
  variables: [
    {
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "ovenTubeSkinTemperature",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: unitTypes.percentage,
      unit: unitDefault.percentage.metric,
      code: "ovenOxygenPercentage",
      groups: "general",
      values: [50, 70, 80, 90],
      min: 0,
      max: 100
    },
    {
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "ovenVacuumPressure",
      groups: "general",
      values: [50, 70, 80, 90],
      min: 0,
      max: 100
    },
    {
      type: unitTypes.flow,
      unit: unitDefault.flow.metric,
      code: "ovenGasInput",
      groups: "general",
      values: [50, 70, 80, 90],
      min: 0,
      max: 100
    },
    {
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "ovenOutputTemperature",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: unitTypes.deathLine,
      unit: timeJump.month.name,
      code: "ovenCatalystLife",
      groups: "general",
      values: [0, 0, timeJump.month.value * 3, timeJump.month.value * 4],
      min: 0,
      max: timeJump.month.value * 6
    },
    {
      type: "flameColor",
      unit: "",
      code: "flameQualityColor",
      groups: "flame",
      min: 0,
      max: 3,
      values: [1, 2, 3, 3]
    },
    {
      type: "flameStability",
      unit: "",
      code: "flameStability",
      groups: "flame",
      min: 0,
      max: 2,
      values: [1, 1, 2, 2]
    }
  ],
  operationalValues: [
    {
      value: 0,
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "ovenOperationPressure"
    },
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "ovenOperationTemperature"
    },
    {
      value: 0,
      type: unitTypes.pressure,
      unit: unitDefault.pressure.metric,
      code: "ovenDesignPressure"
    },
    {
      value: 0,
      type: unitTypes.temperature,
      unit: unitDefault.temperature.metric,
      code: "ovenDesignTemperature"
    },
    {
      value: 0,
      type: unitTypes.power,
      unit: unitDefault.power.metric,
      code: "ovenHeatAbsorption"
    }
  ]
};
